// Loox's dynamic reviews carousel loops by re-showing earlier photos once
// you scroll past the end of the reel — that's expected and left alone.
// The bug this fixes is different: when a product doesn't have many image
// reviews, the same photo sometimes lands in two neighbouring slides, so it
// shows twice side by side in the same view. This only hides a repeat when
// it's within a few slides of its first appearance (i.e. visible together),
// never the distant copy used for the end-of-reel loop.
//
// 2026-09-15: replaced interval-based polling (150ms x20, then 1s x30 - up
// to 33s of unconditional work on every page load) with whenDefined() +
// a document-level MutationObserver. Same coverage, no blind polling: the
// mobile PDP speed backlog (cro/SITE-SPEED.md) makes every bit of avoidable
// main-thread work on page load worth removing.
(function () {
  // How many slides apart still counts as "side by side". Generous enough
  // to cover the widest items-per-view setting in use, far short of the
  // loop clone that sits at the opposite end of the whole slide list.
  var ADJACENCY_WINDOW = 4;
  var TAG = 'loox-dynamic-carousel-widget';

  function dedupeWidget(widget) {
    if (!widget.shadowRoot) return;

    widget.shadowRoot.querySelectorAll('.swiper.image-swiper, .dynamic-carousel-image-swiper-container .swiper').forEach(function (container) {
      var slides = Array.from(container.querySelectorAll('.swiper-slide'));
      var entries = slides.map(function (slide) {
        var img = slide.querySelector('.review-image-wrapper img, img.review-image, img');
        var src = img ? (img.currentSrc || img.src || img.getAttribute('data-src') || '') : '';
        return { slide: slide, key: src.split('?')[0] };
      });

      var changed = false;
      entries.forEach(function (entry, i) {
        if (!entry.key) return;
        // Always start from a clean slate: a slide only stays hidden if we
        // decide again below that it's a near duplicate this pass.
        var wasHidden = entry.slide.style.display === 'none';
        var isNearDuplicate = false;

        for (var j = Math.max(0, i - ADJACENCY_WINDOW); j < i; j++) {
          if (entries[j].key === entry.key) {
            isNearDuplicate = true;
            break;
          }
        }

        entry.slide.style.display = isNearDuplicate ? 'none' : '';
        if (isNearDuplicate !== wasHidden) changed = true;
      });

      if (changed && container.swiper && typeof container.swiper.update === 'function') {
        container.swiper.update();
      }
    });
  }

  // Batch bursts of mutations (lazy-loaded images tend to resolve their
  // src attributes in quick succession) into a single re-check.
  var scheduled = false;
  function scheduleDedupe() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      document.querySelectorAll(TAG).forEach(dedupeWidget);
    });
  }

  function observeWidget(widget) {
    if (widget.__glideDedupeObserved || !widget.shadowRoot) return;
    widget.__glideDedupeObserved = true;
    dedupeWidget(widget);
    // Watch both new slides being added AND existing <img> tags getting
    // their real src/data-src filled in by Loox's own lazy-loading —
    // the latter is how most slides actually resolve, and a plain
    // childList observer misses it entirely.
    new MutationObserver(scheduleDedupe).observe(widget.shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'data-src', 'srcset'],
    });
  }

  function observeAll() {
    document.querySelectorAll(TAG).forEach(observeWidget);
  }

  // Case 1: the <loox-dynamic-carousel-widget> tag is already parsed into
  // the page (as an unresolved custom element) before Loox's own script
  // has loaded. Its shadow root doesn't exist until the browser upgrades
  // it, which happens the instant Loox calls customElements.define() -
  // whenDefined() resolves at exactly that moment, no polling needed.
  if (window.customElements && customElements.get(TAG) === undefined) {
    customElements.whenDefined(TAG).then(observeAll).catch(function () {});
  }

  // Case 2: Loox inserts widget instances into the page later (client-side
  // render, e.g. below the fold). This fires on the same tick as the
  // insertion.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(TAG)) observeWidget(node);
        if (node.querySelectorAll) node.querySelectorAll(TAG).forEach(observeWidget);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Case 3: a widget is both already in the DOM and already upgraded by
  // the time this script itself runs (e.g. this script loaded late).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }
})();
